<template>
  <div style="margin-top: 86px">
    <HomeImage></HomeImage>
    <HomeBody></HomeBody>
  </div>
</template>

<script>
import HomeImage from '../views/Home/HomeImage'
import HomeBody from '../views/Home/HomeBody'
export default {

  name: 'HelloWorld',
  components: {
    HomeBody,
    HomeImage
  },
  data() {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
